export default function Radiobtn({labelClass, isSelectedlabelBold,name, checked, value, bigLabel,  defaultValue, id,onChange,label}){
    
    return (
        <label htmlFor={id} className={labelClass}>
            <input
                type="radio" 
                id={id} 
                checked={checked}
                value={value}
                defaultValue={defaultValue}
                onChange={onChange}
                 name={name} 
                 className="hidden radio_btn_input"  />
            <span>
                <img className="empty-fill-icon" src={process.env.REACT_APP_URL+"images/Polygon-blank.svg"}/>
                <img className="fill-icon" src={process.env.REACT_APP_URL+"images/pol-fill.svg"} />
            </span>
            <p className={` ${(isSelectedlabelBold && checked) ? 'bold-radio-label':''}` }>
                {label}
            </p>
        </label>
    )
}
